import { Stack, Button, Typography} from '@mui/material';
import { ChevronLeftRounded } from '@mui/icons-material';
import React from 'react';
import { theme } from '../../theme';

function DrawerHeader({ handleBack, title }) {

    return (
        <Stack p={1} direction='row' justifyContent='space-between' backgroundColor={theme.palette.background.white}>
            <Button onClick={handleBack} style={{ alignSelf: 'start', color: `${theme.palette.subtext.main}`, width: '62px' }} startIcon={<ChevronLeftRounded />}>Back</Button>
            <Typography variant='bold' sx={{ fontSize: '14px', alignSelf: 'center' }}>{title}</Typography>
            <Stack sx={{ width: '62px' }}></Stack>
        </Stack>
    );
}

export default DrawerHeader;